module.exports = "<svg viewBox=\"0 0 8 13\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.985 6.5L6.557 7.914l-.002-.002-5.135 5.073-1.43-1.414L5.126 6.5-.01 1.43 1.42.013l5.135 5.073h.002L7.985 6.5z\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/svg-inline-loader!./client/components/InstantBookingSpinner/rightArrow.svg
// module id = 646
// module chunks = 0